import {Imap, Ilayer} from "./Config";
interface ITemp{
    levelId: string,
    number: number;
}
export default class GenerateAllPositions {
    private allItem:Array<Ilayer>;
    private temp:Array<ITemp>;
    private startItemId:number;
    constructor(startItem:Ilayer, allItem:Array<Ilayer>){
        this.allItem = allItem;
        this.temp = [];
        this.startItemId = startItem.id;
        this.getLevelId(startItem, null, 'down');

        //szülők szintjén lefele, ez még kell

        this.findUser(this.getParents(startItem), (user)=>{
            var parentLevelId:string = null;
            if ( user.id === startItem.fatherId ) {
                parentLevelId = 'SZ1';
            }else if ( user.id === startItem.motherId ) {
                parentLevelId = 'SZ2';
            }
            this.getLevelId(user, parentLevelId, 'current');
            this.getLevelId(user, parentLevelId, 'up');

            return user;
        });
    }

    private findNextTemp(levelId:string, mode:string, levelIndex:number):string{
        if ( mode === 'down' ) {
            if ( levelId !== 'T' && levelId.indexOf('D') === -1 ) {
                levelId = levelId +'D';
            }
        }else if ( mode === 'up' ) {
            if ( levelId !== 'SZ' && levelId.indexOf('N') === -1 ) {
                levelId = levelId +'N';
            }
        }else{
            // current
            if ( levelId !== 'SZ' && levelId.indexOf('T') === -1 ) {
                levelId = levelId +'T';
            }
        }
        for (var key in this.temp) {
            var item = this.temp[key];
            if (  item.levelId === levelId ) {
                ++ item.number;
                return levelId + item.number;
            }
        }
        this.temp.push({
            levelId: levelId,
            number: 1
        })
        return levelId + '1';
    }

    private getLevelId(item:Ilayer, parentLevelId:string=null, mode:string){
        if ( item.levelId !== null ) {
            this.findUser(item.allBrothers, (user)=>{
                if ( user.levelId === null ) {
                    this.getLevelId(user, parentLevelId, mode);
                }
                return user;
            });
            if (  mode === 'up' ) {
                //get parents
                this.findUser(this.getParents(item), (user)=>{
                    if ( user.levelId === null ) {
                        this.getLevelId(user, parentLevelId, mode);
                    }
                    return user;
                });
            }
            return;
        }
        var itemLevelId:string = null;
        if ( parentLevelId !== null ) {
            item.levelId = this.findNextTemp(parentLevelId, mode, item.levelIndex);
        }else{
            if (  mode === 'up' ) {
                item.levelId = this.findNextTemp('SZ', mode, item.levelIndex);
            }else if (  mode === 'down' ) {
                item.levelId = this.findNextTemp('T', mode, item.levelIndex);
            }else{
                //current mode
                item.levelId = this.findNextTemp('SZ', mode, item.levelIndex);
            }
        }
        itemLevelId = item.levelId;

        if (  mode === 'down' || mode === 'current' ) {
            //get childrens
            this.findUser(item.childrensIds, (user)=>{
                this.getLevelId(user, itemLevelId, mode);
                return user;
            });
        }
        if (  mode === 'up' ) {
            //get parents
            this.findUser(this.getParents(item), (user)=>{
                this.getLevelId(user, itemLevelId, mode);
                return user;
            });
        }

        this.findUser(item.allBrothers, (user)=>{
            this.getLevelId(user, parentLevelId, mode);
            return user;
        });
    }

    public get():Array<Ilayer>{
        return this.allItem;
    }

    private getParents(item:Ilayer):Array<number>{
        var parents:Array<number> = [];
        if ( item.fatherId !== null ) {
            parents.push(item.fatherId);
        }
        if ( item.motherId !== null ) {
            parents.push(item.motherId);
        }
        return parents;
    }

    private findUser(id:number|Array<number>, cb:Function):void{
		if ( typeof id !== "number" ) {
			var ids:Array<number> = id;
			for (var key in ids) {
				var currentId = ids[key];
				if ( currentId > 0 ) {
					for (var key in this.allItem) {
						var item = this.allItem[key];
						if ( item !== undefined && item.id !== undefined && item.id === currentId ) {
							this.allItem[key] = cb(item);
							break;
						}
					}
				}
			}
		}else{
			if ( id > 0 ) {
				for (var key in this.allItem) {
					var item = this.allItem[key];
					if ( item !== undefined && item.id !== undefined && item.id === id ) {
						this.allItem[key] = cb(item);
						return;
					}
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// ./components/family_tree/GenerateAllPositions.ts